import React from 'react';
import { Row, Col, DatePicker, Icon, Divider, Select, Modal } from 'antd';
import { connect } from 'react-redux';
import DVONE from './dataView_one'
import DVTWO from './dataView_two'
import DVTHREE from './dataView_three'
import 'antd/dist/antd.css';
import './dataView.css';
import '../../scripts/config'
import moment from 'moment'


let store;
let $this;
const { RangePicker } = DatePicker;
const { Option } = Select;
class DataViewPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectKey: 0,
            ywmk: 'wcbj',
            ywmc: '围产保健数据中心',
            menudata: [],
            content: null,
            menu: {
                mzmenu: [{ value: '数据概况', label: '数据概况' }, { value: '指标分析', label: '指标分析' }, { value: '趋势分析', label: '趋势分析' }],
                zymenu: [{ value: '总控中心', label: '总控中心' }, { value: '监护中心', label: '监护中心' }, { value: '数据中心', label: '数据中心' }]
            }
        }
        $this = this;
        store = this.props.store;
    };
    //组件载入完成
    componentDidMount() {
        this.menuInit();
    }
    menuInit = () => {
        const ywmk = this.state.ywmk;
        const data = ywmk === 'wcbj' ? this.state.menu.mzmenu : this.state.menu.zymenu;
        this.setState({ menudata: data }, () => {
            this.menClick(0);
        });
    }
    menClick = (index) => {
        const { store } = this.props;
        const _content = index === 0 ? <DVONE store={store}></DVONE> : index === 1? <DVTWO store={store}></DVTWO> : <DVTHREE store={store}></DVTHREE>;
        this.setState({ selectKey: index, content: _content });
    }
    ywmcOnChange = (value, option) => {
        this.setState({ ywmc: option.props.children, ywmk: value }, () => {
            this.menuInit();
        });
    }
    //退出
    powerOffClick = e => {
        Modal.confirm({
            content: '确定要退出当前系统吗?',
            icon: 'question-circle',
            okText: '确定',
            cancelText: '取消',
            onOk: () => {
                $this.props.emitHandler('reLogin', null);
            }
        });
    }
    //返回主页
    homePageClick = e => {
        Modal.confirm({
            content: '确定要回首页吗?',
            icon: 'question-circle',
            okText: '确定',
            cancelText: '取消',
            onOk: () => {
                $this.props.emitHandler('goHomePage', null);
            }
        });
    }
    render() {
        const { store } = this.props;
        return (
            <div className="dv-c" >
                <Row gutter={3} className="dv-c-h">
                    <Col span={8}>
                        <Row gutter={this.state.menudata.length}>
                            {
                                this.state.menudata.map((item, index) => {
                                    return <Col span={24 / this.state.menudata.length} onClick={() => this.menClick(index)} className={this.state.selectKey === index ? "dv-c-h-native dv-c-h-native-active" : "dv-c-h-native"}>{item.label}</Col>;
                                })
                            }
                            {/* <Col span={8} onClick={() => this.menClick('0')} className={this.state.selectKey === '0' ? "dv-c-h-native dv-c-h-native-active" : "dv-c-h-native"}>数据概况</Col>
                            <Col span={8} onClick={() => this.menClick('1')} className={this.state.selectKey === '1' ? "dv-c-h-native dv-c-h-native-active" : "dv-c-h-native"}>指标分析</Col>
                            <Col span={8} onClick={() => this.menClick('2')} className={this.state.selectKey === '2' ? "dv-c-h-native dv-c-h-native-active" : "dv-c-h-native"}>趋势分析</Col> */}
                        </Row>
                    </Col>
                    <Col span={8} className="dv-c-h-center">
                        {this.state.ywmc}
                    </Col>
                    <Col span={8} className='dv-info-content'>
                        <Row gutter={4}>
                            <Col span={18}>{store.objUser.dwmc}<Divider type='vertical'></Divider>{store.objUser.czy_ksmc}</Col>
                            <Col span={6}>
                                <span style={{ cursor: 'pointer' }} onClick={() => this.homePageClick()}>
                                    <Icon type='home'></Icon>首页
                                </span>
                                <Divider type='vertical'></Divider>
                                <span style={{ cursor: 'pointer' }} onClick={() => this.powerOffClick()}>
                                    <Icon type='poweroff'></Icon>注销
                                </span>
                            </Col>
                        </Row>
                        <Row gutter={4}>
                            <Col span={12} className='dv-control-style'>
                                <RangePicker
                                    size='small'
                                    defaultValue={[moment().add('years', -1), moment()]}
                                    format='YYYY-MM-DD'
                                />
                            </Col>
                            <Col span={12} className='dv-control-style'>
                                <Select
                                    showSearch
                                    size='small'
                                    onChange={(value, option) => this.ywmcOnChange(value, option)}
                                    style={{ width: 200 }}
                                    defaultValue={'围产保健数据中心'}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    <Option value="wcbj">围产保健数据中心</Option>
                                    <Option value="ckzy">智慧产科数据中心</Option>
                                </Select>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                {this.state.content}
            </div>
        );
    }
}
//需要渲染什么数据

function mapStateToProps(state) {
    return {
        store: state
    }
}
//需要触发什么行为

function mapDispatchToProps(dispatch) {
    return {
        indexDispatch: (par) => dispatch(
            {
                type: par.type, data: par.data
            }
        )
    }
}
DataViewPage = connect(mapStateToProps, mapDispatchToProps)(DataViewPage);
export default DataViewPage;